// Where a contrato's files live in Storage.
//
// Three layouts, picked from the contract doc:
//   convenio  convenios/{convenioId}/{contractId}
//   link      clientes/{clientId}/{linkId}              (uploaded through an expediente link)
//   directo   clientes/{clientId}/contratos/{contractId} (uploaded straight from the CRM)
//
// Fianza files go under `${base}/contrato/fianzas/{fianzaId}`, contract-level
// documents under `${base}/documentos`. Build every contrato path through
// these helpers; a hand-rolled `clientes/${clientId}/${linkId}/...` writes to
// an `undefined/` folder for any contract without a link.

/**
 * @param {{id: string, convenioId?: string, linkId?: string, clientId?: string}} contrato
 * @param {string} [clientId] Falls back to contrato.clientId.
 */
export function contratoStorageBase(contrato, clientId) {
  if (contrato?.convenioId) return `convenios/${contrato.convenioId}/${contrato.id}`;
  const cid = clientId || contrato?.clientId;
  if (contrato?.linkId) return `clientes/${cid}/${contrato.linkId}`;
  return `clientes/${cid}/contratos/${contrato?.id}`;
}

export function fianzaStoragePath(contrato, clientId, fianzaId) {
  return `${contratoStorageBase(contrato, clientId)}/contrato/fianzas/${fianzaId}`;
}

// Link contracts keep their processing results in links/{linkId}/files;
// convenio and directo contracts keep them in contracts/{id}/procesamiento.
export function usesProcesamiento(contrato) {
  return Boolean(contrato && !contrato.linkId);
}
